import React from "react";
import { pushErrorInGA } from "../../../utils/datalayers";

export const ErrorMessageAlert = (props: {
  errorType: string;
  errorSubType: string;
  message: string;
  children:
    | boolean
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
}): JSX.Element => {
  React.useEffect(() => {
    if (props.message) {
      pushErrorInGA(props.errorType, props.errorSubType, props.message);
    }
  }, [props.message]);

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};
export default ErrorMessageAlert;
